import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import ErrorPage from "../../ErrorPage";

const NoDataAvailableForFilterError = () => {
  const theme = useTheme();
  const { t } = useTranslation("common");
  return (
    <ErrorPage
      title={t("error.filter.noDataAvailable.title")}
      subtitle={t("error.filter.noDataAvailable.subtitle") as string}
      icon={{
        Component: SearchIcon,
        styles: {
          color: theme.tokens.FuelColorGray700,
          height: theme.tokens.FuelFontSize5xl,
          width: theme.tokens.FuelFontSize5xl,
        },
      }}
    />
  );
};

export default NoDataAvailableForFilterError;
